import type { SVGProps } from "react";
import { memo } from "react";
const ResilienceHub = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#B0084D" />
        <stop offset="100%" stopColor="#FF4F8B" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M51 54.118h5.729c-1.967 4.903-6.742 8.167-12.062 8.167-7.168 0-13-5.832-13-13s5.832-13 13-13c6.714 0 12.404 5.233 12.955 11.915l1.994-.164c-.637-7.71-7.203-13.75-14.949-13.75-8.271 0-15 6.728-15 15 0 8.27 6.729 15 15 15 5.662 0 10.79-3.205 13.333-8.142v4.807h2v-8.833h-9zm-13.375-3.78-1.25 1.561 5 4a1 1 0 0 0 1.365-.108l10-11-1.48-1.346-9.368 10.306zM68 42.242c-.03 3.463-1.392 5.647-2.528 6.87l-1.465-1.362c.895-.963 1.969-2.704 1.993-5.525.039-4.583-2.67-7.28-8.28-8.249a1 1 0 0 1-.824-1.09c.365-3.42-1.45-5.394-3.269-6.1-1.843-.715-3.747-.21-4.85 1.287a1.002 1.002 0 0 1-1.749-.261c-.865-2.458-2.596-4.537-3.896-5.848-1.879-1.893-7.033-5.963-14.311-2.868-4.207 1.791-7.503 6.948-7.503 11.741 0 .44.07 1.322.097 1.624a1 1 0 0 1-.747 1.057C18.178 34.16 14 36.133 14 42.151q0 .47.035.911c.358 4.585 3.59 7.664 6.386 7.664h5.51v2h-5.51c-3.674 0-7.922-3.634-8.38-9.507A14 14 0 0 1 12 42.151c0-6.89 4.646-9.434 7.36-10.33a17 17 0 0 1-.042-.983c0-5.627 3.749-11.466 8.72-13.58 5.828-2.48 12.001-1.247 16.514 3.298 1.19 1.201 2.709 2.991 3.76 5.156 1.656-1.283 3.917-1.613 6.039-.79 2.228.865 4.655 3.261 4.59 7.255 7.516 1.615 9.09 6.326 9.06 10.066"
      />
    </g>
  </svg>
);
const Memo = memo(ResilienceHub);
export default Memo;
